import React, { useState } from 'react';

import { IChartData, IChartDetails, IChartSettingsType, ICompareChartIndicators, ISearchMaterialData } from '../interface/futureTable';
import AdvanceExportChartDataPopup from './advanceExportChartPopup';
import ExportChartPopup from './exportChartPopup';

interface IProps {
	chartDetails: IChartDetails;
	span: number | string;
	setAction: (action: string) => void;
	customChartSpan: {
		von: string;
		bis: string;
	};
	chartType: string;
	id: string;
	symbol: string;
	comparativeChartIndicator: ICompareChartIndicators[] | ISearchMaterialData[] | IChartSettingsType[];
	chartSettings: IChartSettingsType[];
	scaleType: string;
	chartData: IChartData[];
	chartPeriod: string;
	forecastKeys: string[];
	chartFrequency: string[];
	selectedDataTypesPerMaterial: { [materialKey: string]: string[] };
	selectedFrequencies: { [materialKey: string]: string };
	allChartDetails: {
		[key: string]: IChartDetails;
	};
}

const ExportDataPopup: React.FC<IProps> = (props) => {
	const {
		customChartSpan,
		span,
		chartDetails,
		setAction,
		chartType,
		id,
		symbol,
		comparativeChartIndicator,
		chartSettings,
		scaleType,
		chartData,
		chartPeriod,
		forecastKeys,
		chartFrequency,
		selectedDataTypesPerMaterial,
		selectedFrequencies,
		allChartDetails
	} = props;
	const [isExcelDownloadOpen, setIsExcelDownloadOpen] = useState(false);
	return (
		<>
			{isExcelDownloadOpen ? (
				<AdvanceExportChartDataPopup
					chartSettings={chartSettings}
					scaleType={scaleType}
					chartDetails={chartDetails}
					chartType={chartType}
					customChartSpan={customChartSpan}
					id={id}
					setAction={setAction}
					span={span}
					symbol={symbol}
					setIsExcelDownloadOpen={setIsExcelDownloadOpen}
					comparativeChartIndicator={comparativeChartIndicator}
					chartPeriod={chartPeriod}
					forecastKeys={forecastKeys}
					chartFrequency={chartFrequency}
					chartData={chartData}
					selectedDataTypesPerMaterial={selectedDataTypesPerMaterial}
					selectedFrequencies={selectedFrequencies}
					allChartDetails={allChartDetails}
				/>
			) : (
				<ExportChartPopup
					chartDetails={chartDetails}
					chartType={chartType}
					customChartSpan={customChartSpan}
					id={id}
					setAction={setAction}
					span={span}
					isExcelDownloadOpen={isExcelDownloadOpen}
					setIsExcelDownloadOpen={setIsExcelDownloadOpen}
					chartData={chartData}
				/>
			)}
		</>
	);
};

export default ExportDataPopup;
